export interface ScreenInterface {
    name: string;
    api?: ScreenAPI;
};
export enum ScreenAPI {
  BRANCH = "/branches",
  OFFERS = "/deglawy/offers",
  PARTNERS = "/deglawy/partners",
  ACADEMIES = "/academies",
  ARTICLES = "/articles?type=news",
  TROPHIES = "/deglawy/trophies",
  FEATURES = "/deglawy/featured",
  WHEEL = "/wheel/events",
}
export const screens: ScreenInterface[] = [
  {
    name: "main",
  },
  {
    name: "Clubs",
  },
  {
    name: "branchesList",
  },
  {
    name: "branchDetails",
    api: ScreenAPI.BRANCH,
  },
  {
    name: "deglawyOffersScreen",
  },
  {
    name: "KenyaOffersScreen",
  },
  {
    name: "deglawyOfferDetailsScreen",
    api: ScreenAPI.OFFERS,
  },
  {
    name: "deglawyPartnersScreen",
  },
  {
    name: "deglawyPartnerBranchesScreen",
    api: ScreenAPI.PARTNERS,
  },
  {
    name: "academyDetails",
    api: ScreenAPI.ACADEMIES,
  },
  {
    name: "deglawyTrophiesDetails",
    api: ScreenAPI.TROPHIES,
  },
  {
    name: "contactUs",
  },
  {
    name: "articleDetails",
    api: ScreenAPI.ARTICLES,
  },
  {
    name: "renewalScreen",
  },
  {
    name: "clubCapacityScreen",
  },
  {
    name: "wifiServices",
  },
  {
    name: "qrScanning",
  },
  {
    name: "freshChatScreen",
  },
  {
    name: "addMembership",
  },
  {
    name: "smsVerification",
  },
  {
    name: "LimitedUserKYCApplicationError",
  },
  {
    name: "resetPassword",
  },
  {
    name: "register",
  },
  {
    name: "gallery",
  },
  {
    name: "login",
  },
  {
    name: "forgotpassword",
  },
  {
    name: "chooseForgotPassMethod",
  },

  {
    name: "deglawyAboutScreen",
  },
  {
    name: "welcomeScreen",
  },
  {
    name: "fawryPaymentScreen",
  },
  {
    name: "academies",
  },
  {
    name: "deglawyFeaturedDetails",
    api: ScreenAPI.FEATURES,
  },
  {
    name: "chooseRegistrationMethodScreen",
  },
  {
    name: "customerServiceUnavailable",
  },
  {
    name: "menu",
  },
  {
    name: "deglawyFamilyMembersScreen",
  },
  {
    name: "store",
  },
  {
    name: "Talent",
  },
  {
    name: "fanSupportScreen",
  },
  {
    name: "waterFrontHomeScreen",
  },
  {
    name: "referalIntro",
  },
  {
    name: "contactListScreen",
  },
  {
    name: "referralEdit",
  },
  {
    name: "referralGift",
  },
  {
    name: "profileScreen",
  },
  {
    name: "changePassword",
  },
  {
    name: "contactUs",
  },
  {
    name: "deglawyAddFamilyMemberScreen",
  },
  {
    name: "adNotificationScreen",
  },
  {
    name: "AccountControl",
  },
  {
    name: "DeglawyFeaturedScreen",
  },
  {
    name: "DeglawyCollectPointsScreen",
  },
  {
    name: "NotificationsList",
  },
  {
    name: "AddSportScreen",
  },
  {
    name: "AddSportFamilyScreen",
  },
  {
    name: "PreviouslyRatedFacility",
  },
  {
    name: "VerifySportsFamilyScreen",
  },
  {
    name: "payMobPaymentScreen",
  },
  {
    name: "paymentOptionsScreen",
  },
  {
    name: "AcademyScheduleScreen",
  },
  {
    name: "forceUpdateScreen",
  },
  {
    name: "orders",
  },
  {
    name: "Settings",
  },
  {
    name: "changeCountry",
  },
  {
    name: "survey",
  },
  {
    name: "ratingFacility",
  },
  {
    name: "fanSupportScreen",
  },
  {
    name: "suspendedUser",
  },
  {
    name: "storeUnavailable",
  },
  {
    name: "pointsPayment",
  },
  {
    name: "RenewalPointsSmsVerificationScreen",
  },
  {
    name: "productScreen",
  },
  {
    name: "checkoutScreen",
  },
  {
    name: "orderdCreated",
  },
  {
    name: "paymentCheckoutScreen",
  },
  {
    name: "clubCapacitySettingsScreen",
  },
  {
    name: "customScreen",
  },
  {
    name: "limitedChangeNumberScreen",
  },
  {
    name: "cardsDeliveryScreen",
  },
  {
    name: "CardsDeliveryServiceScreen",
  },
  {
    name: "mPesaPaymentScreen",
  },
  {
    name: "mPesaPaymentSuccessScreen",
  },
  {
    name: "Notifications",
  },
  {
    name: "wheelOfFortuneScreen",
    api: ScreenAPI.WHEEL,
  },
  {
    name: "leadWheelOfFortuneScreen",
    api: ScreenAPI.WHEEL,
  },
  {
    name: "qrModalScreen",
  },
  {
    name: "newsList",
  },
  {
    name: "easyFinanceAboutScreen",
  },
  {
    name: "deglawyLogScreen",
  },
  {
    name: "validationScreenCard",
  },
  {
    name: "ETicketingHomeScreen",
  },
  {
    name: "MemberSeparation",
  },
  {
    name: "travelMain",
  },
  {
    name: "LoginLeadScreen",
  },
  {
    name: "memberDataUpdateScreen",
  },
  {
    name: "kenyaPointsMain",
  },
  {
    name: "kenyaMemberInfoCustomScreen",
  },
  {
    name: "campusMain",
  },
  {
    name: "liveScooringScreen",
  },
];
